import * as ReactService from "@intech/react-service";
import { JsonWebToken } from "../entidades/JsonWebToken";
import { LoginEntidade } from "../entidades/LoginEntidade";

class Usuario extends ReactService.BaseService {
  constructor() {
    super("Usuario");
  }

  BuscarPrimeiroAcesso = (nomLogin: string) => this.CreateRequest<string>(ReactService.RequestType.GET, `BuscarPrimeiroAcesso/${nomLogin}`);

  Login = (user: LoginEntidade) => this.CreateRequest<any>(ReactService.RequestType.POST, `Login`, user);

  CriarAcesso = (user: LoginEntidade) => this.CreateRequest<string>(ReactService.RequestType.POST, `CriarAcesso`, user);

  CriarAcessoIntech = (data: LoginEntidade) => this.CreateRequest<any>(ReactService.RequestType.POST, `criarAcessoIntech`, data);

  CriarAcessoPrevirb = () => this.CreateRequest<any>(ReactService.RequestType.GET, `criarAcessoPrevirb`);

  AlterarSenha = (user: LoginEntidade) => this.CreateRequest<string>(ReactService.RequestType.POST, `AlterarSenha`, user);

  AlterarSenhaPrimeiroAcesso = (data: LoginEntidade) => this.CreateRequest<string>(ReactService.RequestType.POST, `AlterarSenhaPrimeiroAcesso`, data);

  BuscarMatriculas = () => this.CreateRequest<string[]>(ReactService.RequestType.GET, `BuscarMatriculas`);

  SelecionarMatricula = (login: LoginEntidade) => this.CreateRequest<JsonWebToken>(ReactService.RequestType.POST, `SelecionarMatricula`, login);

  SelecionarParticipante = (login: LoginEntidade) => this.CreateRequest<JsonWebToken>(ReactService.RequestType.POST, `SelecionarParticipante`, login);

}

export const UsuarioService = new Usuario();
